import { render, staticRenderFns } from "./BifoldForm.vue?vue&type=template&id=4648e8e6&"
import script from "./BifoldForm.vue?vue&type=script&lang=js&"
export * from "./BifoldForm.vue?vue&type=script&lang=js&"
import style0 from "./BifoldForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports